import { render, staticRenderFns } from "./widgetSlider.vue?vue&type=template&id=2554bc3d&scoped=true&"
import script from "./widgetSlider.vue?vue&type=script&lang=js&"
export * from "./widgetSlider.vue?vue&type=script&lang=js&"
import style0 from "./widgetSlider.vue?vue&type=style&index=0&id=2554bc3d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2554bc3d",
  null
  
)

export default component.exports